import { render } from "./EditOAuthClient.vue?vue&type=template&id=753d4c1d&scoped=true"
import script from "./EditOAuthClient.vue?vue&type=script&lang=js"
export * from "./EditOAuthClient.vue?vue&type=script&lang=js"

import "./oauth-client.scss?vue&type=style&index=0&id=753d4c1d&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753d4c1d"]])

export default __exports__